import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGetAffiliateAccountsResponse } from "../../api/affiliates/intex.types";

export interface IAffiliatesState {
  accounts: {
    data: IGetAffiliateAccountsResponse["data"]["affiliates"];
    count: IGetAffiliateAccountsResponse["data"]["count"];
    loading: boolean;
  };
}

const initialState: IAffiliatesState = {
  accounts: {
    loading: false,
    data: [],
    count: 0,
  },
};

const index = createSlice({
  name: "affiliates",
  initialState,
  reducers: {
    fetchAccountsRequest: (state) => {
      state.accounts.loading = true;
    },
    fetchAccountsSuccess: (state, action: PayloadAction<IGetAffiliateAccountsResponse["data"]>) => {
      state.accounts.loading = false;
      state.accounts.data = action.payload.affiliates;
      state.accounts.count = action.payload.count;
    },
    fetchAccountsFailed: (state) => {
      state.accounts.loading = false;
    },
  },
});

export const affiliatesActions = index.actions;
export default index.reducer;
